<div class="offers-filter">
  <div class="offers-filter__header">
    <span class="offers-filter__header__title">{{ filter.title | translate }}</span>
    <app-tooltip-icon class="offers-filter__header__tooltip reset-position"
                      *ngIf="filter.tooltip"
                      [outlined]="true"
                      [theme]="'left-align'"
                      [description]="filter.tooltip | translate">
    </app-tooltip-icon>
    <span class="offers-filter__header__tooltip"></span>
  </div>
  <div class="offers-filter__options">
    <form [formGroup]="formGroup">
      <ng-container [ngSwitch]="filter.type">
        <ng-container *ngSwitchCase="'CHECKBOX'">
          <div class="offers-filter__option" *ngFor="let option of filter.options">
            <app-checkbox class="filter-checkbox"
                          [control]="formGroup.controls[option.key]"
                          [bean]="bean"
                          (click)="onCheckboxClick(option)"
                          [fieldConfig]="getFieldConfig(option.key)"
                          [errorsMap]="formFactoryService.errorsMap">
            </app-checkbox>
          </div>
        </ng-container>
        <app-radio *ngSwitchCase="'RADIO'"
                   class="filter-radio"
                   [errorsMap]="formFactoryService.errorsMap"
                   [bean]="bean"
                   [control]="formGroup.controls[filter.key]"
                   [fieldConfig]="getFieldConfig(filter.key)"
        >
        </app-radio>
      </ng-container>
    </form>
  </div>
</div>
